import { render, staticRenderFns } from "./addbank.vue?vue&type=template&id=16b1b506&scoped=true&"
import script from "./addbank.vue?vue&type=script&lang=js&"
export * from "./addbank.vue?vue&type=script&lang=js&"
import style0 from "./addbank.vue?vue&type=style&index=0&id=16b1b506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1b506",
  null
  
)

export default component.exports